module.exports = __webpack_public_path__ + "a56dcc2814babeab5bc8ae505d9cc2b1.MP3";